import { ArrowDownRight, ArrowUpRight, MapPin } from "lucide-react";
import { KineticHeadline } from "@/components/landing/KineticHeadline";
import { LogoMark } from "@/components/shared/LogoMark";

export function Header({ settings, lang, onToggle }) {
  const english = lang === "en";
  return (
    <header className="site-header">
      <a className="brand-lockup" href="#top" data-testid="brand-link" aria-label={settings.brand_name}>
        <LogoMark src={settings.logo_url} className="header-logo" testId="header-brand-logo" />
        <span className="brand-name">Martinez <em>Landscaping</em></span>
      </a>
      <nav className="desktop-nav" aria-label={english ? "Main navigation" : "Navegación principal"}>
        <a href="#services" data-testid="nav-services-link">{english ? "Services" : "Servicios"}</a>
        <a href="#approach" data-testid="nav-approach-link">{english ? "Approach" : "Enfoque"}</a>
        <a href="#work" data-testid="nav-work-link">{english ? "Work" : "Trabajo"}</a>
      </nav>
      <div className="header-actions">
        <a className="admin-link" href="/admin" data-testid="admin-access-link">{english ? "Edit site" : "Editar sitio"}</a>
        <a className="header-call" href="tel:+19804149114" data-testid="header-call-link"><span>Call</span><ArrowUpRight size={15} /></a>
        <button type="button" className="language-switcher" data-testid="language-toggle-button" aria-label={english ? "Cambiar a español" : "Switch to English"} onClick={onToggle}>
          <span className={english ? "language-active" : ""}>EN</span><span className="language-divider">/</span><span className={!english ? "language-active" : ""}>ES</span>
        </button>
      </div>
    </header>
  );
}

export function HeroSection({ settings, lang, heroShift }) {
  const english = lang === "en";
  const hero = settings.hero;
  return (
    <section className="hero-section" id="top">
      <div className="hero-copy">
        <div className="hero-overline"><MapPin size={14} /><span data-testid="hero-location-label">{settings.location_label}</span></div>
        <KineticHeadline lines={english ? hero.headline_en : hero.headline_es} />
        <p className="hero-description" data-testid="hero-description">{english ? hero.description_en : hero.description_es}</p>
        <div className="hero-actions">
          <a className="button button-primary" href="#contact" data-testid="hero-consult-cta-button">{english ? hero.primary_cta_en : hero.primary_cta_es}<ArrowDownRight size={17} /></a>
          <a className="text-link" href="#approach" data-testid="hero-portfolio-cta-button">{english ? hero.secondary_cta_en : hero.secondary_cta_es}<ArrowDownRight size={17} /></a>
        </div>
      </div>
      <div className="hero-visual" style={{ "--hero-shift": `${heroShift}px` }}>
        <div className="hero-frame">
          <img className="hero-image" src={settings.hero_image_url} alt={english ? "Layered residential garden in Charlotte" : "Jardín residencial por capas en Charlotte"} data-testid="hero-landscape-image" />
          <div className="hero-image-caption"><span>{english ? "A landscape should feel lived in." : "Un paisaje debe sentirse vivido."}</span><span>35.2271° N / 80.8431° W</span></div>
        </div>
        <div className="hero-logo-seal">
          <LogoMark src={settings.logo_url} className="hero-logo" testId="hero-logo" />
          <span>{english ? "Local hands · Lasting work" : "Manos locales · Trabajo duradero"}</span>
        </div>
        <div className="hero-index">01 <span>/</span> 04</div>
      </div>
    </section>
  );
}
